import ReactDOM from "react-dom/client";
import App from "./App";
import "./i18n/config"; // initialise i18next avant le rendu
import "simplebar-react/dist/simplebar.min.css";
import "app/presentation/styles/index.css";

// Import du script de test API (uniquement en développement local)
if (import.meta.env.DEV && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
  import("./infrastructure/utils/test-api.js");
}

const rootElement = document.getElementById("root");
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(<App />);
}